module.exports = __webpack_public_path__ + "static/img/11.3925893.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/11.jpg
// module id = BiED
// module chunks = 0